import { isMatrix } from "mathjs";

import { evaluate } from "../../generation/evaluate";
import { StatementExtract } from "./extractStatementsWithinParts";

/**
 * ** Retrieves a single valid variable from a set of variables **
 *
 * For UX reasons, it only picks a valid non string and non matrix values values as they
 * are very prone to typo and can often be unclear at times on what to input
 */
export default function getRandomStatementExtract(
  scope: any,
  statementExtracts: StatementExtract[]
) {
  let itemsToProcess = [...statementExtracts];

  while (itemsToProcess.length > 0) {
    const randIdx = Math.floor(Math.random() * itemsToProcess.length);
    const randomItem = itemsToProcess[randIdx];
    itemsToProcess.splice(randIdx, 1);

    const evaluated = evaluate(scope, randomItem.statementPart.statement);

    if (typeof evaluated !== "string" && !isMatrix(evaluated)) {
      return randomItem;
    }
  }

  return undefined;
}
